import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "w100",
  style: {}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5" }, "項目名", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "alertRed fs12 fw600"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  class: "w100 mt20",
  style: {}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5" }, "説明", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "w100 mt20",
  style: {}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5" }, "プレースホルダー", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "w100 mt20",
  style: {}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt20" }, "選択形式", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  class: "fl ml20 fs16 mt14",
  style: {"width":"20px"}
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  class: "fs14 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt20" }, "選択肢", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "mt10" }
const _hoisted_30 = {
  class: "fr",
  style: {"width":"200px"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: `freeText_freeText`,
  class: "fs12 fw600"
}, "「その他」の選択を許可し、詳細な理由を入力してもらう", -1)
const _hoisted_32 = {
  key: 3,
  class: "w100 mt20",
  style: {}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt20" }, "選択形式", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  class: "fl ml20 fs16 mt14",
  style: {"width":"20px"}
}
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  class: "fs14 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt20" }, "選択肢", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = {
  key: 4,
  class: "w100 mt20",
  style: {}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt5" }, "必須", -1)
const _hoisted_46 = {
  class: "fl",
  style: {"margin-left":"10px"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = {
  key: 0,
  class: "mt20"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 dgrey mb5 mt5 mr5" }, "この回答を会議場所としてセットする", -1)
const _hoisted_50 = { class: "mt3 fl" }
const _hoisted_51 = { class: "fl" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = { class: "fs14 dgrey mb5 mt40" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "fl mt5 mr5" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "fl" }, "表示設定", -1)
const _hoisted_57 = {
  key: 0,
  class: "fl ml5 mr5"
}
const _hoisted_58 = { class: "fl mt5" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = {
  key: 1,
  class: "mt5 ml3"
}
const _hoisted_61 = { key: 2 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_UploadImageButton = _resolveComponent("UploadImageButton")!
  const _component_SelectFieldLi = _resolveComponent("SelectFieldLi")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_FormFieldEditSettingOptionsContent = _resolveComponent("FormFieldEditSettingOptionsContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.field)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_TextfieldTag, {
              placeholder: _ctx.getPlaceholderPlaceholder(),
              style: {"height":"50px"},
              class: "fl fs14 roundForm mw100",
              value: _ctx.field.field_name,
              onInputValue: _ctx.inputNameValue,
              onBlur: _ctx.checkTitle
            }, null, 8, ["placeholder", "value", "onInputValue", "onBlur"]),
            (_ctx.titleErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.titleErrorMessage), 1))
              : _createCommentVNode("", true),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_TextareaTag, {
              placeholder: "説明を追加",
              style: {"border-radius":"8px","text-indent":"0","resize":"none","line-height":"21px","width":"100%","max-width":"100%"},
              class: "fl fs14 roundForm",
              value: _ctx.field.description,
              onInputValue: _ctx.inputDescription
            }, null, 8, ["value", "onInputValue"]),
            _hoisted_11
          ]),
          (
                    !_ctx.selectableTypes.includes(_ctx.field.field_type) &&
                    ![
                        `birthdate`,
                        `head1`,
                        `head2`,
                        `upload_file`,
                        `radio_image`,
                        `checkbox_image`,
                        `image1`,
                        `address`,
                    ].includes(_ctx.field.field_type)
                )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _createVNode(_component_TextfieldTag, {
                  placeholder: `メールアドレス`,
                  style: {"height":"50px"},
                  class: "fl fs14 roundForm mw100",
                  value: _ctx.field.placeholder_attr,
                  onInputValue: _ctx.inputPlaceholderValue
                }, null, 8, ["value", "onInputValue"]),
                _hoisted_15
              ]))
            : (_ctx.field.field_type == `image1`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_UploadImageButton, {
                    onClickButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadSelImage(0)))
                  })
                ]))
              : _createCommentVNode("", true),
          (_ctx.selectableTypes.includes(_ctx.field.field_type))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _hoisted_19,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectTypeIconsArray, (typeDic, typeindex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: typeindex,
                        onClick: ($event: any) => (_ctx.changeSelectType(typeDic)),
                        class: "pointer",
                        style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
                      }, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(typeDic.checked ? `✔` : ` `), 1),
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(typeDic.icon),
                          class: "fl ml15 mt8",
                          width: "28",
                          height: "29"
                        }, null, 8, _hoisted_22),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(typeDic.name), 1)
                      ], 8, _hoisted_20))
                    }), 128))
                  ])
                ]),
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _createVNode(_component_draggable, {
                  modelValue: _ctx.field.selectable_values,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.field.selectable_values) = $event)),
                  "item-key": `selindex`,
                  group: "selectableFieldsGroup",
                  onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = true)),
                  onEnd: _ctx.sortEnd
                }, {
                  item: _withCtx(({ element: selfield, index: selindex }) => [
                    (_openBlock(), _createBlock(_component_SelectFieldLi, {
                      field: _ctx.field,
                      selvalue: selfield.value,
                      selindex: selindex,
                      key: `${selindex}${_ctx.selSystemUpdatedAt}`,
                      onInputSelValue: _ctx.inputSelValue,
                      onDeleteSel: _ctx.deleteSel
                    }, null, 8, ["field", "selvalue", "selindex", "onInputSelValue", "onDeleteSel"]))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onEnd"]),
                _hoisted_27,
                _createElementVNode("div", {
                  class: "w100 centered blueAround pointer circle_button fw600",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addSelectField && _ctx.addSelectField(...args)))
                }, "選択肢を追加"),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_CheckboxTag, {
                      value: `freeText`,
                      name: `freeText`,
                      checked: this.field.allow_free_text,
                      prefix: `freeText`,
                      onClickCheckbox: _ctx.clickFree
                    }, null, 8, ["checked", "onClickCheckbox"]),
                    _hoisted_31
                  ])
                ])
              ]))
            : (_ctx.selectableWithImagesTypes.includes(_ctx.field.field_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", null, [
                    _hoisted_33,
                    _hoisted_34,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectWithImageTypeIconsArray, (typeDic, typeindex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: typeindex,
                          onClick: ($event: any) => (_ctx.changeSelectWithImageType(typeDic)),
                          class: "pointer",
                          style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
                        }, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(typeDic.checked ? `✔` : ` `), 1),
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(typeDic.icon),
                            class: "fl ml15 mt8",
                            width: "28",
                            height: "29"
                          }, null, 8, _hoisted_37),
                          _createElementVNode("p", _hoisted_38, _toDisplayString(typeDic.name), 1)
                        ], 8, _hoisted_35))
                      }), 128))
                    ])
                  ]),
                  _hoisted_39,
                  _hoisted_40,
                  _hoisted_41,
                  _createVNode(_component_draggable, {
                    modelValue: _ctx.field.selectable_values,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.field.selectable_values) = $event)),
                    "item-key": `selindex`,
                    group: "selectableFieldsGroup",
                    onStart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag = true)),
                    onEnd: _ctx.sortEnd
                  }, {
                    item: _withCtx(({ element: selvalue, index: selindex }) => [
                      (_openBlock(), _createBlock(_component_SelectFieldLi, {
                        field: _ctx.field,
                        selvalue: selvalue.value,
                        selindex: selindex,
                        key: `${selindex}${_ctx.selSystemUpdatedAt}`,
                        onInputSelValue: _ctx.inputSelValue,
                        onDeleteSel: _ctx.deleteSel,
                        onUploadSelImage: _ctx.uploadSelImage
                      }, null, 8, ["field", "selvalue", "selindex", "onInputSelValue", "onDeleteSel", "onUploadSelImage"]))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onEnd"]),
                  _hoisted_42,
                  _createElementVNode("div", {
                    class: "w100 centered blueAround pointer circle_button fw600",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addSelectField && _ctx.addSelectField(...args)))
                  }, "選択肢を追加")
                ]))
              : _createCommentVNode("", true),
          _hoisted_43,
          (![`head1`, `head2`, `image1`].includes(_ctx.field.field_type))
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", null, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_Switcher, {
                      value: "type[is_required]",
                      name: "必須",
                      checked: _ctx.field.is_required,
                      display: "true",
                      class: "changeRequiredFlg fl",
                      onSelect: _ctx.changeRequiredFlg,
                      disabled: _ctx.switchDisable()
                    }, null, 8, ["checked", "onSelect", "disabled"])
                  ]),
                  _hoisted_47
                ]),
                (!_ctx.field.is_special)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_IconHelp, {
                          class: "mr10",
                          width: 18,
                          tooltipText: `住所やオンライン会議を開く場合に、お相手の場所で設定したい場合に利用します。\nこの場所で移動考慮をしたい場合は、移動考慮 & フォーム先で設定してください。\n未入力の場合は、オーナーが設定している場所が適用されます。`,
                          style: {"margin-top":"-3px"}
                        })
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_Switcher, {
                          value: "type[is_required]",
                          name: "場所情報としてセット",
                          checked: _ctx.field.change_location_name,
                          display: "true",
                          class: "toggleChangeLocationName fl",
                          onSelect: _ctx.toggleChangeLocationName
                        }, null, 8, ["checked", "onSelect"])
                      ]),
                      _hoisted_52
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/box_half.png`),
                    class: "fl mt1 mr5",
                    width: "23",
                    height: "24"
                  }, null, 8, _hoisted_54),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    (!_ctx.rm.canUseOption(`room_hidden_field_in_form`, false))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createVNode(_component_IconLock, {
                            style: {"margin-top":"-5px"},
                            class: "",
                            width: 16
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_IconHelp, {
                      width: 18,
                      tooltipText: `フォーム入力時に非表示にすることができます。<br>非表示にした質問は、お相手に送られるメールには表示されません。`,
                      style: {"margin-top":"-3px","margin-right":"5px"}
                    })
                  ])
                ]),
                _hoisted_59,
                (!_ctx.rm.canUseOption(`room_hidden_field_in_form`, false))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, "表示（デフォルト）"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createVNode(_component_SelectTag, {
                        name: "display_type",
                        id: "select_display_type",
                        class: "fl fs14 roundForm noBorder",
                        style: {"width":"320px","min-width":"320px","height":"50px"},
                        options: _ctx.displayTypes.map(d => d.name),
                        defaultOption: _ctx.displayType ? _ctx.displayTypes.find(d => d.type == _ctx.displayType).name : `表示`,
                        onSelectValue: _ctx.selectDisplayType
                      }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                      _hoisted_62
                    ])),
                _hoisted_63,
                (_ctx.field.field_type == `birthdate`)
                  ? (_openBlock(), _createBlock(_component_FormFieldEditSettingOptionsContent, {
                      key: 3,
                      editingField: _ctx.field,
                      onUpdateFieldFromChild: _ctx.updateFieldFromChild
                    }, null, 8, ["editingField", "onUpdateFieldFromChild"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}